export const SET_ROUNDS_DATA = 'SET_ROUNDS_DATA';

export const setRoundsData = (roundsData) => ({
    type: SET_ROUNDS_DATA, roundsData
});
